/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lastchangeonjahrgangsstufebyusername6Inputs */

const de__field_lastchangeonjahrgangsstufebyusername6 = /** @type {(inputs: _Field_Lastchangeonjahrgangsstufebyusername6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Änderung der Jahrgangsstufe von`)
};

/**

* @param {_Field_Lastchangeonjahrgangsstufebyusername6Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lastchangeonjahrgangsstufebyusername6 = /** @type {((inputs?: _Field_Lastchangeonjahrgangsstufebyusername6Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lastchangeonjahrgangsstufebyusername6Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_lastchangeonjahrgangsstufebyusername6(inputs)
});
export { _field_lastchangeonjahrgangsstufebyusername6 as "_field_lastChangeOnJahrgangsstufeByUserName" }